import { render } from "./bannerContactUs.vue?vue&type=template&id=702335e7&scoped=true"
import script from "./bannerContactUs.vue?vue&type=script&lang=js"
export * from "./bannerContactUs.vue?vue&type=script&lang=js"

import "./bannerContactUs.vue?vue&type=style&index=0&id=702335e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702335e7"]])

export default __exports__